// Single source of truth for site-wide SEO constants.
// All canonical URLs, schema, and social cards reference these values.
export const SITE_URL = 'https://shipmasterprep.com';
export const SITE_NAME = 'Shipmaster Fulfillment';
export const LEGAL_NAME = 'Shipmaster Fulfillment LLC';

// Default site-wide tagline (used when a page doesn't override).
// Tagline emphasizes Shopify + DTC + South Florida — the three highest-intent
// keyword clusters for this brand.
export const DEFAULT_DESCRIPTION =
  'Modern fulfillment for Shopify and DTC brands. Transparent pricing, fast turnaround, and boutique-level support from South Florida.';

// 1200x630 social card. Generated via Gemini Nano Banana, blueprint-style
// chevron treatment matching the brand mark. See /tmp/gen_og_variants.py
// for the prompt used.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-card.png`;

// Brand contact info used in Organization / LocalBusiness schema.
export const CONTACT = {
  email: 'info@shipmasterprep.com',
  // Phone backlogged — add ContactPoint once a permanent number is set.
  addressLocality: 'Weston',
  addressRegion: 'FL',
  addressCountry: 'US',
};

// Brand social profiles (sameAs in Organization schema). Empty for now —
// add LinkedIn / Instagram / X handles when available.
export const SAME_AS = [];

// Shared keyword positioning. Pages mix-and-match these clusters in their
// title/description copy to feed organic discovery.
export const KEYWORD_CLUSTERS = {
  primary: '3PL fulfillment, Shopify fulfillment, DTC fulfillment, South Florida 3PL',
  service: 'order fulfillment, pick and pack, kitting, ecommerce shipping',
  geo: 'Weston FL, Miami fulfillment, Florida 3PL warehouse',
  channel: 'TikTok Shop fulfillment, Amazon FBM fulfillment, Shopify 3PL',
};
